<template>
  <div class="prologue-start">
    <div align="center">
      <img src="@/assets/images/a.png" class="logo" />
    </div>
    <div class="orange-box">
      <div class="header is-size-large is-text-bold is-uppercase">
        <div>Who pays the next round?</div>
        <div class="subline is-size-small">Let the game decide!</div>
      </div>

      <div class="white-button is-uppercase">
        <div class="is-text-bold" @click="emitSetPrologueStep('intro')">
          {{ $t("prologue.start.cta") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    glassImage() {
      const glassColor = this.$store.state.glassColor;
      return require(`@/assets/images/ice_cold_shot_${glassColor}_start.png`);
    },
  },
  methods: {
    playBackgroundSound() {
      this.backgroundSound.volume = 0.3;
      this.backgroundSound.loop = true;
      this.backgroundSound.play();
    },
    emitSetPrologueStep(step) {
      this.clickSound.play();
      this.$emit("setPrologueStep", step);
    },
  },
  watch: {
    currentStep() {
      if (this.currentStep === "prologue") {
        this.playBackgroundSound();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/assets/sass/abstracts/variables"

.white-button
  background-color: white
  color: black
  border-radius: 1rem
  padding: 1.5rem
  margin-top: 1rem
  text-align: center
  cursor: pointer
  width: 100%

.orange-box
  background-image: url("../../assets/images/orangebg.png")
  background-size: cover
  color: white
  align-items: start
  display: flex
  flex-direction: column
  width: 100%
  border-radius: 3.5rem
  padding: 3rem

.prologue-start
  position: relative
  z-index: 10
  height: 100%
  display: flex
  flex-direction: column
  align-items: center
  justify-content: space-between


.stripe
  height: 12px
  background-color: $color-orange
  width: 80%
  margin-left: 1rem
  margin-top: -2rem
  margin-bottom: 1rem

.subline
  margin-top: 2rem
  margin-bottom: 2rem


.powered_by
  width: 200px
  margin-top: 1rem

.responsive-image
  max-width: 100%
  height: auto

@keyframes moveInRight
  0%
    opacity: 0
    transform: translateX(100rem)

  100%
    opacity: 1
    transform: none

@keyframes fadeInScale
  0%
    opacity: 0
    scale: 2

  100%
    opacity: 1
    scale: 1

@keyframes moveInTop
  0%
    opacity: 0
    transform: translateY(-100px)
  100%
    opacity: 1
    transform: translateY(0)

@keyframes moveInBottom
  0%
    opacity: 0
    transform: translateY(100px)
  100%
    opacity: 1
    transform: translateY(0)

.logo
  animation: moveInTop 0.8s ease-out forwards

.orange-box
  animation: moveInBottom 0.8s ease-out forwards
</style>
